export function fulfillmentPath({ locale = '', resId = '' }) {
 let path = '';

 // check current locale,
 // if not set or en is set
 // then path will start from '/'
 // else '/<local>'
 if (locale != '' && locale != 'en') {
  path = path + `/${locale}`;
 }

 path = path + `/fulfillment/${resId}`;

 console.info('fulfillment path', path);
 return path;
}
